// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__15KgA","colCheckbox":"styles_colCheckbox__1-nyb"};